import React from "react"

export default props => {
  return (
    <div className="mobile-warning">
      <p>Please view on a larger screen</p>
    </div>
  )
}
